import React from 'react'


function Novel(props) {
  return (
     <section>
        <img src={props.img} alt='book1' />
    </section>
  )
}

export default Novel



